module.exports = __webpack_public_path__ + "img/selected3-min.044eec04.png";